app.controller("HeadStartCriteriaController",
	["$scope", "ApartmentSearchService", "BrowserStorageService", "$filter", function($scope, ApartmentSearchService, BrowserStorageService, $filter) {

		var headStartQuery = ApartmentSearchService.CreateQuery();
		var localStorageItem = BrowserStorageService.LocalStorage.GetItem('ApartmentSearchQuery');
		var criteria = headStartQuery.MergeStorageQueryBlob(localStorageItem);
		var i = 0;
		var j = 0;
		var k = 0;
		var criterion = {};

		var addressConstraints = criteria.GetAddressConstraints();
		var priceConstraints = criteria.GetPriceConstraints();
		var extendedConstraints = criteria.GetExtendedConstraints();
		var roomConstraints = criteria.GetRoomConstraints();

		$scope.criteria = [];

		if(addressConstraints !== undefined) {
			criterion.hasValue = false;
			for(i in addressConstraints) {
				if(addressConstraints.hasOwnProperty(i)) {
					if(criterion.hasValue) {
						criterion.value = criterion.value + '; ' + addressConstraints[i].value;
					} else {
						criterion = {'name': 'Hakualue'};
						criterion.hasValue = true;
						criterion.value = addressConstraints[i].value;
					}
				}
			}
			if(criterion.hasValue) {
				$scope.criteria.push(criterion);
			}
		}

		if(priceConstraints !== undefined && (priceConstraints.max < criteria.MAXPRICE || priceConstraints.min > 0) && !criteria.GetRental()) {
			criterion = {'name': 'Hinta'};
			var minvalue = priceConstraints.min ? $filter('currency')(priceConstraints.min, '', ',', ' ', 0) + ' 000' : '';
			var maxvalue = priceConstraints.max ? $filter('currency')(priceConstraints.max, '', ',', ' ', 0) + ' 000' : '';

			if (!minvalue) {
				criterion.value = 'Alle ' + maxvalue;
			} else if (!maxvalue) {
				criterion.value = 'Alkaen ' + minvalue;
			} else {
				criterion.value = minvalue + ' - ' + maxvalue;
			}
			criterion.value += ' €';

			if (minvalue || maxvalue) {
				$scope.criteria.push(criterion);
			}
		}

		if(roomConstraints !== undefined) {
			criterion.hasValue = false;
			for(i in roomConstraints) {
				if(roomConstraints.hasOwnProperty(i)) {
					if(roomConstraints[i]) {
						if(!criterion.hasValue) {
							criterion = {'name': 'Huoneet'};
							criterion.hasValue = true;
							criterion.value = (+i + 1) + 'h';
						} else {
							criterion.value = criterion.value + ', ' + (+i + 1) + 'h';
						}

						if(i == 4) {
							criterion.value = criterion.value + '+';
						}
					}
				}
			}
			if(criterion.hasValue) {
				$scope.criteria.push(criterion);
			}
		}

		if(criteria.GetRental()) {
			criterion = {'name': 'Kohdetyyppi', 'value': 'Vuokra-asunto'};
		} else {
			criterion = {'name': 'Kohdetyyppi', 'value': 'Omistusasunto'};
		}
		$scope.criteria.push(criterion);

		if (criteria.GetRental()) {
			criterion = { 'name': 'Vuokra' };

			var rentmin = criteria.GetRentalPriceConstraints().min || null;
			var rentmax = criteria.GetRentalPriceConstraints().max || null;

			var rentMinPrice = rentmin ? $filter('currency')(rentmin, '', ',', ' ', 0) : '';
			var rentMaxPrice = rentmax ? $filter('currency')(rentmax, '', ',', ' ', 0) : '';

			if (!rentMinPrice) {
				criterion.value = 'Alle ' + rentMaxPrice;
			} else if (!rentMaxPrice) {
				criterion.value = 'Alkaen ' + rentMinPrice;
			} else {
				criterion.value = rentMinPrice + ' - ' + rentMaxPrice;
			}
			criterion.value += ' € / kk';

			if (rentMinPrice || rentMaxPrice) {
				$scope.criteria.push(criterion);
			}
		}

		if(extendedConstraints !== undefined) {
			for(i in extendedConstraints) {
				if(extendedConstraints.hasOwnProperty(i)) {
					criterion = {'name': extendedConstraints[i].name};
					criterion.hasValue = false;
					if(extendedConstraints[i].internalId == 'area') {
						if(extendedConstraints[i].data.min > extendedConstraints[i].data.floor || extendedConstraints[i].data.max < extendedConstraints[i].data.ceil) {
							if(extendedConstraints[i].data.min == extendedConstraints[i].data.floor) {
								criterion.value = 'Alle ' + extendedConstraints[i].data.max + extendedConstraints[i].data.unit;
							} else if(extendedConstraints[i].data.max == extendedConstraints[i].data.ceil) {
								criterion.value = 'Vähintään ' + extendedConstraints[i].data.min + extendedConstraints[i].data.unit;
							} else {
								criterion.value = extendedConstraints[i].data.min + extendedConstraints[i].data.unit + "-" + extendedConstraints[i].data.max + extendedConstraints[i].data.unit;
							}
							$scope.criteria.push(criterion);
						}
						continue;
					}
					if(extendedConstraints[i].internalId == 'year-built') {
						if(extendedConstraints[i].data[1].data.max < extendedConstraints[i].data[1].data.ceil ||
							extendedConstraints[i].data[1].data.min > extendedConstraints[i].data[1].data.floor) {
							criterion.hasValue = true;
							if (extendedConstraints[i].data[1].data.max == extendedConstraints[i].data[1].data.ceil) {
								criterion.value = extendedConstraints[i].data[1].data.min + ' jälkeen';
							} else if(extendedConstraints[i].data[1].data.min == extendedConstraints[i].data[1].data.floor) {
								criterion.value = 'Ennen ' + extendedConstraints[i].data[1].data.max;
							} else {
								criterion.value = extendedConstraints[i].data[1].data.min + '-' + extendedConstraints[i].data[1].data.max;
							}
						}
						if(extendedConstraints[i].data[0]['selected'] !== 0) {
							criterion.hasValue = true;
							if(criterion.value !== undefined) {
								criterion.value = criterion.value + ', ' + extendedConstraints[i].data[0].data[extendedConstraints[i].data[0]['selected']].name;
							} else {
								criterion.value = extendedConstraints[i].data[0].data[extendedConstraints[i].data[0]['selected']].name;
							}
						}
						if(criterion.hasValue) {
							$scope.criteria.push(criterion);
						}
						continue;
					}
					for(j in extendedConstraints[i].data) {
						if(extendedConstraints[i].data.hasOwnProperty(j)) {
							if(extendedConstraints[i].data[j].value) {
								criterion.hasValue = true;
								if (typeof(criterion.value) != 'undefined') {
									criterion.value = criterion.value + ', ';
									criterion.value = criterion.value + extendedConstraints[i].data[j].name;
								} else {
									criterion.value = extendedConstraints[i].data[j].name;
								}
							}
						}
					}
					if(criterion.hasValue) {
						$scope.criteria.push(criterion);
					}
				}
			}
		}
	}]
);